<template>
    <fat-tribal-details-ag-grid v-if="isActiveAccount" :params="params" />
    <fat-tribal-details-simple v-else-if="isVisible" :params="params"/>
    <div v-else />
</template>

<script setup lang="ts">
import {LedgerAccount} from '@/types/reports/LedgerAccount'
import {computed, Ref} from 'vue'
import FatTribalDetailsAgGrid from '@/tribal/FatTribalDetailsAgGrid.vue'
import FatTribalDetailsSimple from '@/tribal/FatTribalDetailsSimple.vue'

const props = defineProps({
    params: {
        type: Object as () => {
            data: LedgerAccount,
            node: { rowIndex: number },
            context: {
                panelId: Number,
                panelPathSegment: String,
                searchParams: Ref<{
                    fromDate: string,
                    toDate: string
                }>,
                setActiveAccount: Function,
                activeAccountNo: Ref<string>,
                visibleRange?: Ref<{ startIndex: number, endIndex: number }>
            }
        }
    }
})

const isActiveAccount = computed(() => {
    return props.params?.data?.accountNo && (props.params?.data?.accountNo === props.params?.context?.activeAccountNo.value)
})

const isVisible = computed(() => {
    if (!props.params?.node || !props.params.context.visibleRange) return false
    const nodeIndex = props.params.node.rowIndex
    const visibleRange = props.params.context.visibleRange.value
    if (!visibleRange) return false
    return nodeIndex >= visibleRange.startIndex && nodeIndex <= visibleRange.endIndex
})

</script>

<style scoped>

</style>